//File edited by SPRENTZO ON 25TH AUGUST 2026- 'Changed the In Stock and related options in the Cart UI and added additional error handling accordingly'





// import { d as debounce } from './debounce-f0994045.js';
// import { E as EVENTS } from './events-55e4fd80.js';

// class QuantityInput extends HTMLElement {
//   connectedCallback() {
//     this.input = this.querySelector("[js-quantity-input");
//     this.minusButton = this.querySelector("[js-quantity-minus]");
//     this.plusButton = this.querySelector("[js-quantity-plus]");
//     this.debounce = debounce();

//     this.input.addEventListener("keyup", this.handleInputKeyup.bind(this));
//     this.input.addEventListener("change", this.handleInputChange.bind(this));
//     this.minusButton.addEventListener(
//       "click",
//       this.handleButtonClick.bind(this),
//     );
//     this.plusButton.addEventListener("click", this.handleButtonClick.bind(this));

//     this.lastValue = this.input.value;
//     this.updateInputWidth();
//   }

//   /**
//    * Updates the input width based on the number of digits in the value (as the value is typed).
//    */
//   handleInputKeyup() {
//     this.updateInputWidth();
//   }

//   /**
//    * Emits a custom event when the input value has changed. Contains references to the input and each button.
//    */
//   handleInputChange(event) {
//     this.updateInputWidth();

//     const inputChangeEvent = new CustomEvent(EVENTS.QUANTITY_INPUT_CHANGE, {
//       bubbles: true,
//       detail: {
//         input: this.input,
//         minusButton: this.minusButton,
//         plusButton: this.plusButton,
//         quantity: parseInt(this.input.value, 10),
//         previousQuantity: parseInt(this.lastValue, 10),
//       },
//     });

//     this.dispatchEvent(inputChangeEvent);

//     this.lastValue = this.input.value;
//   }

//   /**
//    * Adjusts the input value depending on which button was clicked.
//    * @param {object} event - The "click" event.
//    */
//   handleButtonClick(event) {
//     event.preventDefault();

//     const currentQuantity = parseInt(this.input.value, 10);
//     const minQuantity = parseInt(this.input.getAttribute("min"), 10);

//     if (event.currentTarget === this.minusButton) {
//       const newQuantity = currentQuantity - 1;

//       this.input.value = Math.max(newQuantity, minQuantity);
//     } else {
//       this.input.value = currentQuantity + 1;
//     }

//     this.updateInputWidth();

//     // Debounce triggering the "change" event so that consecutive clicks don't overload things
//     this.debounce(() => this.input.dispatchEvent(new Event("change")));
//     return false
//   }

//   /**
//    * Updates the input width based on the number of digits in the value.
//    */
//   updateInputWidth() {
//     this.input.style.setProperty("--num-chars", this.input.value.length);
//   }

//   /**
//    * Allows the value to be updated externally
//    */
//   setQuantity(value) {
//     this.input.value = value;
//     this.updateInputWidth();
//   }

//   disconnectedCallback() {
//     this.input.removeEventListener("change", this.handleInputChange);
//     this.minusButton.removeEventListener("click", this.handleButtonClick);
//     this.plusButton.removeEventListener("click", this.handleButtonClick);
//   }
// }

// if (!customElements.get("quantity-input")) {
//   customElements.define("quantity-input", QuantityInput);
// }


import { d as debounce } from './debounce-f0994045.js';
import { E as EVENTS } from './events-55e4fd80.js';

class QuantityInput extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector("[js-quantity-input]");
    this.minusButton = this.querySelector("[js-quantity-minus]");
    this.plusButton = this.querySelector("[js-quantity-plus]");
    this.debounce = debounce();

    //Commented out the entirety of the message for better UI and added an error message accordingly 
    // // Create the message element (we removed the hardcoded red color so we can change it dynamically)
    // this.stockMessage = document.createElement('div');
    // this.stockMessage.style.cssText = 'font-size: 16px; margin-top: 6px; font-weight: 500; width: 100%;';
    // this.after(this.stockMessage);

    this.input.addEventListener("keyup", this.handleInputKeyup.bind(this));
    this.input.addEventListener("change", this.handleInputChange.bind(this));
    this.minusButton.addEventListener("click", this.handleButtonClick.bind(this));
    this.plusButton.addEventListener("click", this.handleButtonClick.bind(this));

    this.productForm = this.getForm();
    this.setupVariantTracking();

    this.lastValue = this.input.value;
    this.updateInputWidth();
    
    // Initial evaluation
    setTimeout(() => this.evaluateStockLimit(), 100);
  }

  getForm() {
    const formId = this.input.getAttribute('form');
    if (formId) return document.getElementById(formId);
    return this.closest('form') || document.querySelector('form[action*="/cart/add"]');
  }

  setupVariantTracking() {
    if (!this.productForm) return;

    const idInput = this.productForm.querySelector('input[name="id"]');
    if (idInput) {
      this.variantObserver = new MutationObserver(() => {
        this.syncQuantityWithVariant();
      });
      this.variantObserver.observe(idInput, { attributes: true, attributeFilter: ['value'] });
    }

    let lastUrl = location.href;
    document.body.addEventListener('click', () => {
      setTimeout(() => {
        if (location.href !== lastUrl) {
          lastUrl = location.href;
          this.syncQuantityWithVariant();
        }
      }, 150);
    });
  }

  syncQuantityWithVariant() {
    const maxQuantity = this.getDynamicMax();
    const currentQuantity = parseInt(this.input.value, 10);
    
    if (maxQuantity !== null && currentQuantity > maxQuantity) {
      this.input.value = maxQuantity; 
      this.updateInputWidth();
    }
    this.evaluateStockLimit();
  }

  getDynamicMax() {
    const mapEl = document.querySelector('[data-inventory-map]');
    if (mapEl) {
      try {
        const inventoryMap = JSON.parse(mapEl.textContent);
        let currentVariantId = null;

        if (this.productForm) {
          const idInput = this.productForm.querySelector('input[name="id"]');
          if (idInput && idInput.value) {
            currentVariantId = idInput.value;
          }
        }

        if (!currentVariantId) {
          const urlParams = new URLSearchParams(window.location.search);
          currentVariantId = urlParams.get('variant');
        }

        if (currentVariantId && inventoryMap[currentVariantId]) {
          const variantData = inventoryMap[currentVariantId];
          if (variantData.management === 'shopify' && variantData.policy === 'deny') {
            return variantData.quantity;
          }
          return null; 
        }
      } catch (e) {
        console.error("Error reading inventory data", e);
      }
    }
    
    const maxAttr = this.input.getAttribute("max");
    return maxAttr ? parseInt(maxAttr, 10) : null;
  }

  // NEW: Updated Logic for > 10 stock and color changing
  // evaluateStockLimit() {
  //   const currentQuantity = parseInt(this.input.value, 10);
  //   const maxQuantity = this.getDynamicMax();

  //   // Default: Reset button to active state
  //   this.plusButton.disabled = false;
  //   this.plusButton.style.opacity = '1';
  //   this.plusButton.style.cursor = 'pointer';
  //   this.stockMessage.style.display = 'block';

  //   if (maxQuantity !== null) {
  //     if (currentQuantity >= maxQuantity) {
  //       // Limit reached: Disable button, show red text
  //       this.plusButton.disabled = true;
  //       this.plusButton.style.opacity = '0.4'; 
  //       this.plusButton.style.cursor = 'not-allowed';
        
  //       this.stockMessage.textContent = `Only ${maxQuantity} left in stock.`;
  //       this.stockMessage.style.color = '#d82c0d'; // Red
  //     } else if (maxQuantity > 10) {
  //       // High stock (>10): Keep button active, show green "In stock"
  //       this.stockMessage.textContent = 'In stock';
  //       this.stockMessage.style.color = '#008060'; // Shopify Green/Teal
  //     } else {
  //       // Low stock (1-10): Keep button active, show red warning
  //       this.stockMessage.textContent = `Only ${maxQuantity} left in stock.`;
  //       this.stockMessage.style.color = '#d82c0d'; // Red
  //     }
  //   } else {
  //     // Unlimited stock (no max limit tracking): Show green "In stock"
  //     this.stockMessage.textContent = 'In stock';
  //     this.stockMessage.style.color = '#008060'; // Shopify Green/Teal
  //   }
  // }

//Newer Stocklimit function
evaluateStockLimit() {
  const currentQuantity = parseInt(this.input.value, 10);
  const maxQuantity = this.getDynamicMax();

  // Default: plus button is active
  this.plusButton.disabled = false;
  this.plusButton.style.opacity = '1';
  this.plusButton.style.cursor = 'pointer';

  // Disable plus button when stock limit is reached
  if (maxQuantity !== null && currentQuantity >= maxQuantity) {
    this.plusButton.disabled = true;
    this.plusButton.style.opacity = '0.4';
    this.plusButton.style.cursor = 'not-allowed';
  }
}


  handleInputKeyup() {
    this.updateInputWidth();
  }

  handleInputChange(event) {
    const currentQuantity = parseInt(this.input.value, 10);
    const maxQuantity = this.getDynamicMax();

    // if (maxQuantity !== null && currentQuantity > maxQuantity) {
    //   this.input.value = maxQuantity; 
    // }
    if (maxQuantity !== null && currentQuantity > maxQuantity) {
  this.input.value = maxQuantity;

  alert(`Stock limit exceeded. Only ${maxQuantity} available.`);
}

    this.updateInputWidth();
    this.evaluateStockLimit();

    const inputChangeEvent = new CustomEvent(EVENTS.QUANTITY_INPUT_CHANGE, {
      bubbles: true,
      detail: {
        input: this.input,
        minusButton: this.minusButton,
        plusButton: this.plusButton,
        quantity: parseInt(this.input.value, 10),
        previousQuantity: parseInt(this.lastValue, 10),
      },
    });

    this.dispatchEvent(inputChangeEvent);
    this.lastValue = this.input.value;
  }

  handleButtonClick(event) {
    event.preventDefault();

    if (event.currentTarget === this.plusButton && this.plusButton.disabled) {
        return false;
    }

    const currentQuantity = parseInt(this.input.value, 10);
    const minQuantity = parseInt(this.input.getAttribute("min"), 10) || 1;
    const maxQuantity = this.getDynamicMax();

    if (event.currentTarget === this.minusButton) {
      const newQuantity = currentQuantity - 1;
      this.input.value = Math.max(newQuantity, minQuantity);
    } else {
      const newQuantity = currentQuantity + 1;
      if (maxQuantity !== null && newQuantity >= maxQuantity) {
        this.input.value = maxQuantity;
      } else {
        this.input.value = newQuantity;
      }
    }

    this.updateInputWidth();
    this.evaluateStockLimit(); 
    
    this.debounce(() => this.input.dispatchEvent(new Event("change")));
    return false;
  }

  updateInputWidth() {
    this.input.style.setProperty("--num-chars", this.input.value.length);
  }

  setQuantity(value) {
    this.input.value = value;
    this.updateInputWidth();
    this.evaluateStockLimit();
  }

  disconnectedCallback() {
    if (this.variantObserver) this.variantObserver.disconnect();
    this.input.removeEventListener("change", this.handleInputChange);
    this.minusButton.removeEventListener("click", this.handleButtonClick);
    this.plusButton.removeEventListener("click", this.handleButtonClick);
    // if(this.stockMessage) this.stockMessage.remove();
  }
}

if (!customElements.get("quantity-input")) {
  customElements.define("quantity-input", QuantityInput);
}